<template>
  <RouterLink
    v-if="!shouldOpenWithNativeAnchor && shouldUseRouterLinkForHref(href)"
    :to="hrefToRouteLocation(href)"
    v-bind="$attrs"
  >
    <slot />
  </RouterLink>
  <a v-else :href="href" :target="target" :rel="rel" v-bind="$attrs">
    <slot />
  </a>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { RouterLink } from 'vue-router';

import { hrefToRouteLocation, shouldUseRouterLinkForHref } from '@/utils/spaNavigation';

const props = defineProps<{
  href: string;
  target?: string;
  rel?: string;
}>();

const shouldOpenWithNativeAnchor = computed(
  () => props.target !== undefined && props.target !== '_self'
);
</script>
